module.exports = __webpack_public_path__ + "img/head.0c6d3339.png";